<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a><i class="el-icon-arrow-right"></i><a>工作室列表</a></p>
            </div>
        </div>
        <div class="contentRes"> 
            <div class="contentList">
                <div style="padding: 20px 30px;background: #FFFFFF;">
                    <div v-for="(item,index) in StuDataList" :key="index" class="StuImg">
                        <img :src="http + item.logoUrl" alt="" srcset="" @click="goDetail(item)">
                    </div>

                </div>
            </div>
            <div style="">
                <div class="contentListRight">
                    <div style="margin: 19px 31px 28px 23px;padding-top:20px">
                        <div class="contentListTopR">
                            <div class="contentListLineR"></div><span>温馨提示</span>
                        </div>
                        <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                            本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ft-com></ft-com>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
export default {
    components: {
        hdCom,
        ftCom,
    },
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        return {
            consultationDomain: consultationMainItem,
            http:'',
            orgId:this.$route.query.id,
            StuDataList:[]
        }
    },
    mounted(){
        this.http = this.Services.ossUpload;
        this.GetStuDataListData()
    },
    methods: {
        goDetail(e){
            this.$router.push({
                path: "./studioListDetail",
                query:{
                    id:e.id
                }
            });
        },
        GetStuDataListData(){
            var _this = this;
            _this.consultationDomain.GetAppletStudioGroupListStu(_this.orgId,'0','-1',function (data) {
                 _this.StuDataList = data.data
            },
            function (error) {
                 _this.StuDataList = []
                console.log('', error)
            })
        }
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.content {
  width: 1200px;
    margin: 0 auto;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.bannerImg {
    height: 150px;
    background: linear-gradient(90deg, #12C7AC, #00AFB5);
    border-radius: 6px 6px 0px 0px;
}
.bannerImg img {
    width: 330px;
    height: 120px;
    margin-left: 32px;
    margin-top: 20px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
    padding: 20px 30px;
    padding-bottom: 0px;
    cursor: pointer;
    border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
   padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00A8AE;
  border-bottom: 2px solid #00A8AE;
}
.contentList {
    margin-top: 20px;
    /* background: #FFFFFF; */
    width: 800px;

}
.contentListTop {
    display: flex;
    align-items: center;
}
.contentListTop3 {
    display: flex;
    align-items: center;
    position: relative;
     cursor: pointer;
}
.contentListLine {
    width: 3px;
    height: 20px;
    background: #00AFB5;
    border-radius: 2px;
}
.contentListTop span {
   font-size: 20px;
   margin-left: 10px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.StuImg {
    width: 100%;
    height: 180px;
    border-radius: 6px;
    margin-bottom: 20px;
}
.StuImg img {
    width: 100%;
    height: 100%;
    border-radius: 6px;

}
</style>
